import { selectStripeCustomer } from '../../../../../store/workspace/selectors';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { useSelector } from '../../../../../store/store';
import { useMemo } from 'react';
import CardForm from './CardForm';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUB_KEY || '123');

/** Stripe context the card form needs, kept out of the form itself. */
export default function AddNewCard() {
    const stripeCustomer = useSelector(selectStripeCustomer);

    /** Elements re-mounts whenever its options change identity. */
    const options = useMemo(
        () => ({ clientSecret: stripeCustomer?.client_secret }),
        [stripeCustomer?.client_secret],
    );

    return (
        <Elements options={options} stripe={stripePromise}>
            <CardForm />
        </Elements>
    );
};
